import { useContext } from 'react';
import { UserContext } from 'src/contexts/UserContext';
import { useRoutes } from 'react-router-dom';
import routes from './routes';

function AppRoutes() {
    const { isLoggedIn, typeUser } = useContext(UserContext);
    const routing = useRoutes(routes(isLoggedIn, typeUser));
    return routing;
}

export default AppRoutes;